/* eslint-disable no-restricted-globals */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import { connected, lazyImport } from '@ambiki/impulse';
import Rails from '@rails/ujs';
import setupAxios from 'lib/axios';
import { metaValue } from 'helpers/dom-helper';
import { updateCountToHeader } from 'lib/helpers';
import showToast from 'lib/toast_notification';
import SessionPoller from '../lib/session-poller';
import '../controllers';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../stylesheets/vendor/plyr.css';
import '../stylesheets/application.scss';
import initializeDatepickers from '../lib/datepickers';
import clearSearch from '../lib/clear_search';
import initSelectize from '../lib/selectize_init';

import { onDropdownClose } from '../helpers/selectize_helpers';
import computeDisciplines from '../helpers/credentials-disciplines';
import '@ambiki/impulse-view-components/dist/elements/autocomplete';
import '@ambiki/impulse-view-components/dist/elements/popover';
import '@ambiki/impulse-view-components/dist/elements/dialog';
import 'ajax_partial/ajax_partial_element';
import 'jquery-ui';
import 'form';
import 'payroll';
import 'users';
import 'lib/popover';
import 'lib/tooltip';
import 'lib/warn_unsaved_changes';
import 'calendar';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require.context('../fonts/', true, /\.(eot|ttf|woff|woff2|otf)$/i);

// Bundle the teletherapy avatar SVGs so they resolve via image_pack_tag in views
// (see AvatarHelper). These were previously pulled in by the now-removed v1 room pack.
require.context('../images/rooms/avatars/', false, /\.svg$/i);

Rails.start();
import '@hotwired/turbo-rails';
require('@rails/activestorage').start();
require('channels');
require('../lib/session-poller');
require('bootstrap');
require('../lib/datatables/datatables-init');
require('../helpers/nested-fields/addFields');
require('../helpers/nested-fields/diagnosisCodes');
require('../helpers/nested-fields/removeFields');
const selectize = require('@selectize/selectize');
require('../lib/selectize_patch');

require('../lib/autocomplete');
require('../lib/mobile-search');
require('../lib/turbo-reloader');
require('helpers/trix-editors');
require('@rails/actiontext');
require('../custom-elements');
require('../lib/dexie');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/sortable');

window.$ = $;

// Turbo Drive is started automatically by @hotwired/turbo-rails
// Poll for automatic logout detection and redirection
new SessionPoller().init();

// Impulse elements
lazyImport('dynamic-editor', () => import('dynamic_editor/elements/dynamic_editor_element'));
lazyImport('stripe-attach-card', () => import('patients/elements/stripe_attach_card_element'));
lazyImport('patient-payment-method-form', () => import('patients/elements/patient_payment_method_form_element'));
lazyImport('patient-invoice-consolidation-form', () => import('patients/elements/patient_invoice_consolidation_form_element'));
lazyImport('patient-payment-form', () => import('patients/elements/patient_payment_form_element'));
lazyImport('waiting-area', () => import('teletherapy/elements/waiting_area_element'));
lazyImport('password-field', () => import('auth/elements/password_field_element'));
lazyImport('service-log-form', () => import('patients/elements/service_log_form_element'));
lazyImport('strong-password', () => import('auth/elements/strong_password_element'));
// Sortable checkboxes
lazyImport('checkbox-manager', () => import('sortable_checkboxes/elements/checkbox_manager_element'));
lazyImport('checkbox-sortable', () => import('sortable_checkboxes/elements/checkbox_sortable_element'));
lazyImport('checkbox-sortable-item', () => import('sortable_checkboxes/elements/checkbox_sortable_item_element'));
// Visual schedule
lazyImport('vs-manager', () => import('visual_schedules/elements/vs_manager_element'));
lazyImport('vs-card-list', () => import('visual_schedules/elements/vs_card_list_element'));
lazyImport('vs-card-selector', () => import('visual_schedules/elements/vs_card_selector_element'));
lazyImport('vs-card-creator', () => import('visual_schedules/elements/vs_card_creator_element'));
lazyImport('vs-check-off', () => import('visual_schedules/elements/vs_check_off_element'));
lazyImport('vs-first-then', () => import('visual_schedules/elements/vs_first_then_element'));
lazyImport('vs-first-then-item', () => import('visual_schedules/elements/vs_first_then_item_element'));
lazyImport('vs-plan-completed', () => import('visual_schedules/elements/vs_plan_completed_element'));
lazyImport('vs-plan-completed-item', () => import('visual_schedules/elements/vs_plan_completed_item_element'));
lazyImport('vs-trash-can', () => import('visual_schedules/elements/vs_trash_can_element'));
lazyImport('vs-image-reveal-manager', () => import('visual_schedules/elements/vs_image_reveal_manager_element'));
lazyImport('vs-image-reveal-row', () => import('visual_schedules/elements/vs_image_reveal_row_element'));
lazyImport('vs-image-reveal', () => import('visual_schedules/elements/vs_image_reveal_element'));
lazyImport('vs-simple-timer', () => import('visual_schedules/elements/vs_simple_timer_element'));

// Page specific — one-time lazy load for modules that use connected() or custom elements
// internally (lazyImport fires once, the module's own connected/element lifecycle handles re-runs).
lazyImport('.fm-partial', () => import('../pages/organization_dashboards/financial_pulse'));
lazyImport('.load_stripe', () => import('subscriptions'));
lazyImport('#billingDataModal', () => import('../pages/billing_modal_service_rates'));

// Page specific — per-page DOM init (uses connected: fires for each instance, including
// elements re-inserted by Turbo navigation).
connected('#superbill-automation-table', () => {
  import('../pages/superbill_automation').then(({ default: init }) => init());
});
connected('#service-log-management-table', () => {
  import('../pages/service_log_management').then(({ default: init }) => init());
});
connected('[data-page="authorized-signers"]', () => {
  import('../pages/authorized_signers').then(({ default: init }) => init());
});
connected('#custom-form-title', () => {
  window.showToast = showToast;
});
connected('#patient-document-tag-table', () => {
  import('../pages/patient_document_tags').then(({ default: init }) => init());
});
connected('#custom-sanitizer-whitelist', () => {
  import('../lib/tooltip_sanitization').then(({ default: init }) => init());
});
connected('#goals-show', () => {
  import('../pages/goals-show').then(({ default: init }) => init());
});
connected('#taxonomy_search', () => {
  import('../pages/focus-area-tags-form').then(({ default: init }) => init());
});
connected('#goal_form', () => {
  import('../pages/goals_form').then(({ default: init }) => init());
});
connected('#tenalog-editor-container', () => {
  import('../pages/tenalog_editor').then(({ default: init }) => init());
});
connected('#heatmap-calendar', () => {
  import('../pages/patient_progress').then(({ default: init }) => init());
});
connected('#tenalog-credit-form', () => {
  import('../pages/subscription_index').then(({ default: init }) => init());
});
connected('#mvp_reel', () => {
  import('../pages/mvp_reels').then(({ default: init }) => init());
});
connected('#therapy_activities_show', () => {
  import('../pages/therapy_activities').then(({ default: init }) => init());
});
connected('#stg_ltg_goals_show', () => {
  import('../pages/stg_ltg_goals').then(({ default: init }) => init());
});
connected('#words-show', () => {
  import('../pages/words-show').then(({ default: init }) => init());
});
connected('#admin-dashboard-stats', () => {
  import('../pages/admin-dashboard-stats').then(({ default: init }) => init());
});
connected('#phoeneme-graphs', () => {
  import('../pages/phoneme-graphs').then(({ default: init }) => init());
});
connected('.makeup-visits-data-loader', () => {
  import('../pages/organization_dashboards/makeup_visits').then(({ default: init }) => init());
});
connected('.implementation-dashboard', () => {
  import('../pages/organization_dashboards/implementation').then(({ default: init }) => init());
});
connected('#visit-note-therapy-activities-table', () => {
  import('../pages/visit_note_therapy_activities').then(({ default: init }) => init());
});
connected('#connection-stat-container', () => {
  import('../pages/rooms-sessions-webrtc-stats').then(({ default: init }) => init());
});
connected('#pacingGraph', () => {
  import('../pages/cache-pacing-graph-show').then(({ default: init }) => init());
});
connected('#blog-post-form', () => {
  import('../pages/blog_posts').then(({ default: init }) => init());
});
connected('#games-show', () => {
  import('../pages/games_show').then(({ default: init }) => init());
});
connected('#hourly-activity-chart', () => {
  import('../pages/visit-audit-chart').then(({ default: init }) => init());
});
connected('#rules_condition_modal_anchor', () => {
  import('../pages/rules-edit').then(({ default: init }) => init());
});

// Page specific — element-aware init (passes the matched element to the module's default export).
connected('#patient_form', (element) => {
  import('../pages/patient_edit_form').then(({ default: init }) => init(element));
});
connected('#stripe-patient-portal-card-payment-form', (element) => {
  import('../pages/patient_portal_cc_form').then(({ default: init }) => init(element));
});
connected('#signature-pad-canvas', (element) => {
  import('../signature-pad/main').then(({ default: init }) => init(element));
});

// Page specific — chart loaders. Each loader element fires `ajax-partial:loadend` after its
// partial finishes loading; we wire the listener once per element via `connected`, then
// dynamically import the chart module on the first event so the chunk doesn't load until needed.
connected('.dashboard-partial-chart-loader', (element) => {
  element.addEventListener('ajax-partial:loadend', () => {
    import('../pages/organization_dashboards/organization-dashboard-graphs').then(({ default: init }) => init());
  });
});
connected('.dashboard-partial-attendance-chart-loader', (element) => {
  element.addEventListener('ajax-partial:loadend', (event) => {
    import('../pages/organization_dashboards/attendance-graphs').then(({ default: init }) => init(event.target));
  });
});
connected('.dashboard-partial-ledger-chart-loader', (element) => {
  element.addEventListener('ajax-partial:loadend', (event) => {
    import('../pages/organization_dashboards/ledger-graphs').then(({ default: init }) => init(event.target));
  });
});
connected('.dashboard-partial-location-chart-loader', (element) => {
  element.addEventListener('ajax-partial:loadend', (event) => {
    import('../pages/organization_dashboards/location-graphs').then(({ default: init }) => init(event.target));
  });
});

// Session recording: WaveSurfer needs the transcript tab pane to be visible (have a layout box)
// before it can render, so we can't initialize on `#waveform` connection. Instead, we preload
// the chunk as soon as the session-recording tabs nav appears in the DOM, then `initSessionRecording`
// (called from the turbo:load handler below) reuses the cached promise to run the init the
// moment the transcript tab becomes active.
let sessionRecordingModulePromise;
function loadSessionRecording() {
  sessionRecordingModulePromise ||= import('../pages/session_recording');
  return sessionRecordingModulePromise;
}
lazyImport('#v-pills-SessionRecordingTabs', loadSessionRecording);

// If using a third party plugin like selectize.js that manipulates the DOM,
// unhook it from the elements it's attached to before Turbo caches it.
document.addEventListener('turbo:before-cache', () => {
  removeModals();

  $('.selectized').each(function() {
    if (this.selectize) {
      this.selectize.destroy();
    }
  });

  function removeModals() {
    $('.modal').removeClass('in');
    $('.modal').attr('aria-hidden', 'true');
    $('.modal').css('display', 'none');
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  }
});

// Issue: Turbo does not reset scroll position when a new link is clicked
// Try clicking a link the footer to reproduce.
// Using window.scrollTo(0, 0) causes the page to jump to top of the current page before loading
// the new page which is jarring.

(function() {
  // Tell the browser not to handle scrolling when restoring via the history or when reloading
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  const SCROLL_POSITION = 'scroll-position';
  const PAGE_INVALIDATED = 'page-invalidated';

  // Listen for Turbo page invalidation to flag the following page load
  document.addEventListener('turbo:reload', () => {
    sessionStorage.setItem(PAGE_INVALIDATED, 'true');
  });

  // Persist the scroll position when leaving a page
  addEventListener('beforeunload', () => {
    sessionStorage.setItem(
      SCROLL_POSITION,
      JSON.stringify({
        scrollX,
        scrollY,
        location: location.href,
      })
    );
  });

  // When a page is fully loaded:
  // 1. Get the persisted scroll position
  // 2. If the locations match and the load did not originate from a page invalidation, scroll to the persisted position
  // 3. Remove the persisted information
  addEventListener('DOMContentLoaded', (event) => {
    const scrollPosition = JSON.parse(sessionStorage.getItem(SCROLL_POSITION));

    if (shouldScroll(scrollPosition)) {
      scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
    }

    sessionStorage.removeItem(SCROLL_POSITION);
    sessionStorage.removeItem(PAGE_INVALIDATED);
  });

  function shouldScroll(scrollPosition) {
    return (
      scrollPosition &&
      scrollPosition.location === location.href &&
      !JSON.parse(sessionStorage.getItem(PAGE_INVALIDATED))
    );
  }
})();

document.addEventListener('ajax:beforeSend', (event) => {
  const xhr = event.detail[0];
  if (!xhr) return;

  // Add `X-API-AUTH-TOKEN` header before the request
  const authToken = metaValue('api-auth-token');
  if (authToken) {
    xhr.setRequestHeader('X-API-AUTH-TOKEN', `Token token=${authToken}`);
  }

  // The client id that is used by action cable to broadcast calendar changes.
  const clientId = metaValue('client-id');
  if (clientId) {
    xhr.setRequestHeader('X-CID', clientId);
  }
});

function initSessionRecording() {
  loadSessionRecording().then((module) => {
    if (module.default) module.default();
  });
}

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

window.scrollToTop = scrollToTop;

document.addEventListener('turbo:load', (event) => {
  setupAxios({ serializeParams: false });
  // Poller hack to refresh page and maintain scroll position after refresh
  if (window.scrollPosition) {
    window.scrollTo.apply(window, [...window.scrollPosition]);
    window.scrollPosition = null;
  }

  // set up datepickers on page
  initializeDatepickers();

  // Define the event handler function
  function disableOnSubmitHandler(clickEvent) {
    clickEvent.preventDefault();
    const targetButton = clickEvent.currentTarget;
    const initialButtonHTML = targetButton.innerHTML;
    targetButton.disabled = true;
    targetButton.innerHTML = '<i class="bi bi-spinner bi-spin"></i> Submitting...';
    const form = targetButton.closest('form');
    if (form?.checkValidity()) {
      // Since this is a user action, we will also need to fire a `submit` event.
      // Ideally, we want to set the `bubbles` and `cancelable` option to `true`, and invoke `form.submit()` if the event
      // wasn't `preventDefault`d. Since this code is being used in a lot of places, we risk breaking changes because
      // Turbo would take over the form submission and some error flash messages would never render on the page.
      form.dispatchEvent(new Event('submit'));
      form.submit();
    } else {
      // Reset button on failed form validity
      targetButton.disabled = false;
      targetButton.innerHTML = initialButtonHTML;
      form.reportValidity();
    }
  }

  // Select all buttons with the class 'disable-on-submit'
  document.querySelectorAll('.disable-on-submit').forEach((button) => {
    // Remove any existing event listeners
    button.removeEventListener('click', disableOnSubmitHandler);
    // Attach the event listener
    button.addEventListener('click', disableOnSubmitHandler);
  });

  // Define the event handler function
  function disableAllOnSubmitHandler(clickEvent) {
    clickEvent.preventDefault();

    const allButtons = document.querySelectorAll('.disable-btn-on-submit');
    const allButtonsInnerHtml = {};

    allButtons.forEach((btn) => {
      const initialButtonHTML = btn.innerHTML;
      // Use a unique identifier for each button
      const { buttonId } = btn.dataset;
      allButtonsInnerHtml[buttonId] = initialButtonHTML;
      btn.disabled = true;
      btn.innerHTML = '<i class="bi bi-spinner bi-spin"></i> Submitting...';
    });

    // Submit the closest form
    const form = clickEvent.target.closest('form');
    if (form?.checkValidity()) {
      // Since this is a user action, we will also need to fire a `submit` event.
      // Ideally, we want to set the `bubbles` and `cancelable` option to `true`, and invoke `form.submit()` if the event
      // wasn't `preventDefault`d. Since this code is being used in a lot of places, we risk breaking changes because
      // Turbo would take over the form submission and some error flash messages would never render on the page.
      form.dispatchEvent(new Event('submit'));
      form.submit();
    } else {
      // Reset all buttons on failed form validity
      allButtons.forEach((btn) => {
        const { buttonId } = btn.dataset;
        btn.disabled = false;
        btn.innerHTML = allButtonsInnerHtml[buttonId];
      });
      form.reportValidity();
    }
  }

  // Attach the event listeners
  document.querySelectorAll('.disable-all-on-submit').forEach((button) => {
    // Remove existing listener to prevent duplication
    button.removeEventListener('click', disableAllOnSubmitHandler);
    // Attach the event listener
    button.addEventListener('click', disableAllOnSubmitHandler);
  });

  // mount selectize

  // messages form and progress report form relies on this to reupdate form when changes are made
  $('.m-select.filterable')
    .selectize({
      create: false,
      sortField: 'id',
      onDropdownClose,
    })
    .on('change', (e) => {
      e.target.dispatchEvent(new Event('selectize-change'));
    });

  // Physical orders selectize component for custom date dropdown.
  $('.po-select.filterable')
    .selectize({
      create: false,
      sortField: 'id',
      onDropdownClose,
    })
    .on('change', (e) => {
      const dateRange = document.getElementById('po-date-range');
      const startDate = document.getElementById('po-start-date');
      const endDate = document.getElementById('po-end-date');
      if (e.target.value === 'custom') {
        dateRange.classList.remove('hidden');
        startDate.setAttribute('required', 'true');
        endDate.setAttribute('required', 'true');
      } else {
        dateRange.classList.add('hidden');
        startDate.removeAttribute('required');
        endDate.removeAttribute('required');
      }
    });

  // Handle product change for manual subscription items form
  // Initialize manual subscription product select separately with onChange handler
  const manualSubscriptionProductSelect = $('.manual-subscription-item-product');
  if (manualSubscriptionProductSelect.length) {
    manualSubscriptionProductSelect.selectize({
      create: false,
      sortField: 'id',
      onDropdownClose,
      onChange(value) {
        const descriptionField = document.getElementById('manual_subscription_item_description');
        if (descriptionField) {
          // Get the selected option's text (product name)
          const selectedOption = this.options[value];
          if (selectedOption && selectedOption.text) {
            descriptionField.value = selectedOption.text;
          }
        }
      },
    });
  }

  // set up selectize filterables (excluding manual subscription product select)
  const filterables = $('.select.filterable:not(.manual-subscription-item-product)').selectize({
    create: false,
    sortField: 'id',
    onDropdownClose,
  });

  $('.select.treatability').selectize({
    create: false,
    sortField: 'id',
    onDropdownClose,
    render: {
      option(data, escape) {
        return `<div style="padding: 7px;">${escape(data.text)}<br><small style="color:gray;">${escape(
          data.description
        )}</small></div>`; // https://stackoverflow.com/a/36514076
      },
    },
  });

  // Setup multi select with selectize().
  $('.multi-select').selectize({
    create: false,
    plugins: ['remove_button'],
    searchField: ['text', 'optgroup'],
    delimiter: ',',
  });

  $('.multi-select-custom').selectize({
    plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    create(input) {
      return {
        value: input,
        text: input,
      };
    },
    searchField: ['text'],
  });

  $('.select.filterable-text').selectize({
    create: false,
    sortField: 'text',
    onDropdownClose,
  });

  $('.select.filterable-text-with-create').selectize({
    create: true,
    sortField: 'text',
    onDropdownClose,
  });

  if (!selectize.prototype.positionDropdownOriginal) {
    selectize.prototype.positionDropdownOriginal = selectize.prototype.positionDropdown;
    selectize.prototype.positionDropdown = function () {
      if (this.settings.dropdownDirection === 'up') {
        const { $control } = this;
        const offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();

        this.$dropdown.css({
          width: $control.outerWidth(),
          top: offset.top - this.$dropdown.outerHeight(),
          left: offset.left,
        });
        this.$dropdown.addClass(`direction-${this.settings.dropdownDirection}`);
        this.$control.addClass(`direction-${this.settings.dropdownDirection}`);
        this.$wrapper.addClass(`direction-${this.settings.dropdownDirection}`);
      } else {
        selectize.prototype.positionDropdownOriginal.apply(this, arguments);
      }
    };
  }

  $('.select.filterable-text-up').selectize({
    create: false,
    sortField: 'text',
    dropdownDirection: 'up',
    onDropdownClose,
  });

  const noSortFilterables = $('.select.filterable-no-sort').selectize({
    create: false,
    onDropdownClose,
  });

  const reviewForm = document.getElementById('ambiki-review');

  if (reviewForm) {
    const stars = document.querySelectorAll('.star');

    stars.forEach((star) => {
      star.addEventListener('click', () => {
        const { rating } = star.dataset;
        document.querySelector('#review_rating').value = rating;

        stars.forEach((s) => {
          s.textContent = s.dataset.rating <= rating ? '★' : '☆';
        });
      });
    });

    const form = document.querySelector('form[data-rating-required="true"]');

    form.addEventListener('submit', (ratingEvent) => {
      const rating = document.querySelector('#review_rating').value;

      if (!rating) {
        ratingEvent.preventDefault();
        alert('The rating is required. Please select a rating. Thank you!');
      }
    });
  }

  const referenceLinkForm = document.getElementById('reference_link_modal_form');
  if (referenceLinkForm) {
    referenceLinkForm.addEventListener('ajax:error', () => {
      document.getElementById('completion-message').innerHTML =
        '<div class="alert alert-danger" role="alert">Sorry, there was a problem saving your reference link.</div>';
    });
  }

  let sessionRecordingInitialized = false;

  const transcriptTab = document.getElementById('v-pills-transcript-tab');
  if (transcriptTab) {
    if (transcriptTab.classList.contains('active') && !sessionRecordingInitialized) {
      initSessionRecording();
      sessionRecordingInitialized = true;
    }
  }

  $('#v-pills-SessionRecordingTabs a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    const target = $(e.target).attr('href');
    if (target === '#v-pills-transcript' && !sessionRecordingInitialized) {
      initSessionRecording();
      sessionRecordingInitialized = true;
    }
  });

  const lazyLoadAuthCounts = document.querySelectorAll('.auth-count-loader');
  if (lazyLoadAuthCounts) {
    window.pageJSLoading = true;

    lazyLoadAuthCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'auth_total_count';
        const resultId = 'authorization_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  const lazyLoadAlertCounts = document.querySelectorAll('.alert-count-loader');
  if (lazyLoadAlertCounts) {
    window.pageJSLoading = true;

    lazyLoadAlertCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'alert_total_count';
        const resultId = 'alerts_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  const makeupVisitHomePagePartial = document.getElementById('makeup-visit-homepage-partial');
  if (makeupVisitHomePagePartial) {
    window.pageJSLoading = true;
    makeupVisitHomePagePartial.addEventListener('ajax-partial:loadend', () => {
      document.querySelectorAll('.assign-makeup').forEach((el) => {
        el.addEventListener('ajax:before', (event) => {
          document.querySelectorAll('.assign-makeup').forEach((element) => {
            $(element).addClass('link-disabled').attr('aria-disabled', 'true').attr('tabindex', '-1').off('click');
          });
        });
        el.addEventListener('ajax:success', (event) => {
          makeupVisitHomePagePartial.fetch?.();
        });
      });
      const assignedCountId = 'makeup_visits_assigned_to_me_total_count';
      const assignedResultId = 'makeup_visits_assigned_total_count_header';
      updateCountToHeader(assignedCountId, assignedResultId);
      const availableCountId = 'makeup_visits_available_total_count';
      const availableResultId = 'makeup_visits_available_total_count_header';
      updateCountToHeader(availableCountId, availableResultId);
    });
    window.pageJSLoading = false;
  }

  const lazyLoadBirthdayCounts = document.querySelectorAll('.birthday-count-loader');
  if (lazyLoadBirthdayCounts) {
    window.pageJSLoading = true;

    lazyLoadBirthdayCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'birthday_total_count';
        const resultId = 'birthday_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  const lazyTeammateDetailsCounts = document.querySelectorAll('.teammate-details-count-loader');
  if (lazyTeammateDetailsCounts) {
    window.pageJSLoading = true;

    lazyTeammateDetailsCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'teammate_details_total_count';
        const resultId = 'teammate_details_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  const lazyLoadEmdCounts = document.querySelectorAll('.emd-count-loader');
  if (lazyLoadEmdCounts) {
    window.pageJSLoading = true;

    lazyLoadEmdCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'emd_total_count';
        const resultId = 'emd_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  const lazyLoadDnaCounts = document.querySelectorAll('.dna-count-loader');
  if (lazyLoadDnaCounts) {
    window.pageJSLoading = true;

    lazyLoadDnaCounts.forEach((element) => {
      element.addEventListener('ajax-partial:loadend', () => {
        const totalId = 'dna_total_count';
        const resultId = 'dna_header_count';
        updateCountToHeader(totalId, resultId);
      });
    });
    window.pageJSLoading = false;
  }

  clearSearch();

  initSelectize();

  // Used in app/views/organizations_users/_add_permission_group_modal.html.erb
  $('select.add-permission-groups').selectize({
    onDropdownClose,
    // DUMMY FOR NOW
  });

  const credentialSelectHandler = () => {
    const credentialFields = document.querySelectorAll('.select.credential-select');
    const credentialFieldsValues = Array.from(credentialFields).map((field) => field.value);
    computeDisciplines(credentialFieldsValues);
  };

  const credentialFields = document.querySelectorAll('.select.credential-select');
  if (credentialFields.length > 0) {
    const credentialFieldsValues = Array.from(credentialFields).map((field) => field.value);
    computeDisciplines(credentialFieldsValues, false);
    // this sucks (because any of the filterables might not be a credential-select) but I can't figure out any other way
    filterables.on('change', credentialSelectHandler);
  }

  const genderPronoun = document.getElementById('gender_pronoun_select');
  const genderPronounWriteIn = document.getElementById('gender_pronoun_write_in');
  const genderPronounWriteInContainer = document.getElementById('gender_pronoun_write_in_container');

  const genderPronounSelectHandler = (selectEvent) => {
    if (selectEvent.target.value === 'cdc8f7a6-ea5f-4de4-9565-2564df008018') {
      genderPronounWriteInContainer.classList.remove('hidden');
    } else {
      genderPronounWriteInContainer.classList.add('hidden');
      genderPronounWriteIn.value = '';
    }
  };

  if (genderPronoun) {
    noSortFilterables.on('change', genderPronounSelectHandler);
  }

  const backgroundJobRows = document.querySelectorAll('.background_job_expand_handler');
  if (backgroundJobRows) {
    backgroundJobRows.forEach((jobIcon) => {
      const jobId = `background_job_expand_job_${jobIcon.id.split('_')[5]}`;
      jobIcon.onclick = () => {
        document.getElementById(jobId).classList.toggle('background_job_handler_row');
        if (jobIcon.classList.contains('bi-plus-circle')) {
          jobIcon.classList.replace('bi-plus-circle', 'bi-dash-circle');
        } else {
          jobIcon.classList.replace('bi-dash-circle', 'bi-plus-circle');
        }
      };
    });
  }
});
